import React, { Fragment } from 'react';
import { arrayOf, object, string } from 'prop-types';

import Icon from 'foundations/Icons/Icon';

import styles from './Steps.css';

const Steps = ({ steps, title }) => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <ul className={styles.steps}>
        {steps.map((step, i) => (
          <Fragment key={`step-${i}`}>
            <li className={styles.step}>
              <div className={styles.circle}>
                <Icon customClasses={styles.icon} {...step.icon} />
              </div>
              <p className={styles.desc}>
                {step.description}
              </p>
            </li>
            {
              i < 2 && (
                <Icon  
                  customClasses={styles.arrow}
                  icon="arrow-right"
                  type="40"
                  responsive
                />
              )
            }
          </Fragment>
        ))}
      </ul>
    </div>
  );
};

Steps.propTypes = {
  steps: arrayOf(object),
  title: string
};

Steps.displayName = 'Steps';

export default Steps;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/MediaBanner/LeftSide/Steps/Steps.js